function r() {
  let n, l;
  const t = new Promise((e, c) => {
    n = e, l = c;
  });
  t.status = "pending", t.catch(() => {
  });
  function s(e) {
    Object.assign(t, e), delete t.resolve, delete t.reject;
  }
  return t.resolve = (e) => {
    s({
      status: "fulfilled",
      value: e
    }), n(e);
  }, t.reject = (e) => {
    s({
      status: "rejected",
      reason: e
    }), l(e);
  }, t;
}
export {
  r as pendingThenable
};
//# sourceMappingURL=contact-channels165.js.map
